import * as types from './types'

export default {
  [types.SET_SURVEY_DATA](state, payload) {
    state.survey = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clientsurvey/mutations.js